/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import * as THREE from 'three';
// import { MathUtils } from 'three';
import { gsap } from "gsap";
import { MATERIAL_THICKNESS as MT } from '@/box/constants.js'
import { CLIPPING_FIX_OFFSET } from './constants.js'

const HALF_MT = MT / 2;

/**
 * Calculates the width, height, and depth of a 3D object in Three.js.
 *
 * @param {THREE.Object3D} object - The Three.js object to measure.
 * @return {Object} An object containing the width, height, and depth of the input object.
 */
function getObjectDimensions(object) {
  const boundingBox = new THREE.Box3().setFromObject(object);

  const width = boundingBox.max.x - boundingBox.min.x;
  const height = boundingBox.max.y - boundingBox.min.y;
  const depth = boundingBox.max.z - boundingBox.min.z;

  return {
      width: width,
      height: height,
      depth: depth
  };
}

/**
 * Calculates the center point of the given object's bounding box.
 *
 * @param {THREE.Object3D} object - The object for which to calculate the center.
 * @returns {THREE.Vector3} The center point of the object's bounding box.
 */
function getObjectCenter(object) {
  const boundingBox = new THREE.Box3().setFromObject(object);
  const center = boundingBox.getCenter(new THREE.Vector3());

  return center;
}

function putDebugCube(parent, position) {
  const cubeGeo = new THREE.SphereGeometry(0.5, 4, 2);
  const cubeMat = new THREE.MeshStandardMaterial({
    wireframe: true,
    color: 0xFF0000,
  })
  const cubeMesh = new THREE.Mesh(cubeGeo, cubeMat);

  cubeMesh.position.copy(position);
  parent.add(cubeMesh);
}

function setPanelMaterials(group) {
  group.children.forEach(async (p) => {
    // if panelName is not defined or empty, skip
    if (!p.panelName) return;

    p.outsideMatIndex = 0
  });
}
function foldPanels(box, group) {
  const {
    width: boxWidth,
    length: boxLength,
    depth: boxDepth
  } = box;

  group.position.y += box.getDocumentHeight()

  const panels = group.children.filter((p) => {
    return p.panelName
  })

  panels.forEach((p) => {
    // get panel dimensions (width, height, depth)
    let dim = getObjectDimensions(p)

    if(p.panelName) {

      if(p.panelName.includes('glueFlap')) {
        p.rotation.y = Math.PI / 2
        p.position.x += dim.width / 2 + HALF_MT + 2*CLIPPING_FIX_OFFSET;
        p.position.z += dim.width / 2 - HALF_MT + CLIPPING_FIX_OFFSET;
      }
  
      if(p.panelName.includes('side1')) {

        if(p.panelName.includes('Flap')) {

          if(p.panelName.includes('Top')) {
            p.rotation.x = -Math.PI / 2
            // The 4*CLIPPING_FIX_OFFSET is to fix the clipping issue on closed box
            p.position.y += dim.height / 2 + HALF_MT - 4*CLIPPING_FIX_OFFSET;
            p.position.z += dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET;    
          }

          if(p.panelName.includes('Bottom')) {
            p.rotation.x = Math.PI / 2
            // The 4*CLIPPING_FIX_OFFSET is to fix the clipping issue on closed box
            p.position.y -= dim.height / 2 + HALF_MT - 4*CLIPPING_FIX_OFFSET;
            p.position.z += dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET;    
          }

        }

      }  
  
      if(p.panelName.includes('side2')) {
        p.rotation.y = -Math.PI / 2
        p.position.x -= dim.width / 2 + HALF_MT - CLIPPING_FIX_OFFSET;
        p.position.z += dim.width / 2 - HALF_MT + CLIPPING_FIX_OFFSET;
  
        // Flaps are 1 MT narrower than sides
        if(p.panelName.includes('Flap')) {
          p.position.x -= MT
          p.position.z += MT
  
          if(p.panelName.includes('Top')) {
            const quaternion = new THREE.Quaternion();
  
            // Set rotation (for example, rotate 90 degrees around the Z-axis)
            const euler = new THREE.Euler(0, 0, -Math.PI / 2, 'XYZ'); // Euler angles in radians
            quaternion.setFromEuler(euler);
  
            // Apply quaternion rotation to the object
            p.applyQuaternion(quaternion);
  
            p.position.y += dim.height / 2 + HALF_MT - CLIPPING_FIX_OFFSET
            p.position.x -= dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
          }
  
          if(p.panelName.includes('Bottom')) {
            const quaternion = new THREE.Quaternion();
  
            // Set rotation (for example, rotate 90 degrees around the Z-axis)
            const euler = new THREE.Euler(0, 0, Math.PI / 2, 'XYZ'); // Euler angles in radians
            quaternion.setFromEuler(euler);
  
            // Apply quaternion rotation to the object
            p.applyQuaternion(quaternion);
  
            p.position.y -= dim.height / 2 + HALF_MT - CLIPPING_FIX_OFFSET
            p.position.x -= dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
          }
  
        }
      }
  
      if(p.panelName.includes('side3')) {
        p.rotation.y = -Math.PI
        p.position.x -= boxWidth + boxLength + CLIPPING_FIX_OFFSET;
        p.position.z += boxWidth - MT + 2*CLIPPING_FIX_OFFSET;
  
        // Flaps are 1 MT narrower than sides
        if(p.panelName.includes('Flap')) {
          if(p.panelName.includes('Top')) {
            p.rotation.x = Math.PI / 2
            p.position.z -= dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
            // The 4*CLIPPING_FIX_OFFSET is to fix the clipping issue on closed box
            p.position.y += dim.height / 2 + HALF_MT - 4*CLIPPING_FIX_OFFSET
          }
          if(p.panelName.includes('Bottom')) {
            p.rotation.x = -Math.PI / 2
            p.position.z -= dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
            // The 4*CLIPPING_FIX_OFFSET is to fix the clipping issue on closed box
            p.position.y -= dim.height / 2 + HALF_MT - 4*CLIPPING_FIX_OFFSET
          }
        }
      }
  
      if(p.panelName.includes('side4')) {
        p.rotation.y = Math.PI / 2
        p.position.x -= boxLength + boxWidth + boxLength + dim.width / 2 + HALF_MT - MT + 2*CLIPPING_FIX_OFFSET;
        p.position.z += dim.width / 2 - HALF_MT + CLIPPING_FIX_OFFSET;
  
        // Flaps are 1 MT narrower than sides
        if(p.panelName.includes('Flap')) {
          p.position.x -= MT
          p.position.z += MT
  
          // Improper rotation
          if(p.panelName.includes('Top')) {
            const quaternion = new THREE.Quaternion();
  
            // Set rotation (for example, rotate 90 degrees around the Z-axis)
            const euler = new THREE.Euler(0, 0, Math.PI / 2, 'XYZ'); // Euler angles in radians
            quaternion.setFromEuler(euler);
  
            // Apply quaternion rotation to the object
            p.applyQuaternion(quaternion);
  
            p.position.y += dim.height / 2 + HALF_MT - CLIPPING_FIX_OFFSET
            p.position.x += dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
          }
  
          if(p.panelName.includes('Bottom')) {
            const quaternion = new THREE.Quaternion();
  
            // Set rotation (for example, rotate 90 degrees around the Z-axis)
            const euler = new THREE.Euler(0, 0, -Math.PI / 2, 'XYZ'); // Euler angles in radians
            quaternion.setFromEuler(euler);
  
            // Apply quaternion rotation to the object
            p.applyQuaternion(quaternion);
  
            p.position.y -= dim.height / 2 + HALF_MT - CLIPPING_FIX_OFFSET
            p.position.x += dim.height / 2 - HALF_MT + CLIPPING_FIX_OFFSET
          }
  
        }
      }
    }
  });
}

function initLidAnimation(group) {
  const tl = gsap.timeline({ paused: true });

  const side1TopFlapPivotPoint = new THREE.Object3D();
  const side2TopFlapPivotPoint = new THREE.Object3D();
  const side3TopFlapPivotPoint = new THREE.Object3D();
  const side4TopFlapPivotPoint = new THREE.Object3D();

  const side1TopFlap = group.children.find(c => c.panelName.includes('side1TopFlap'));
  const side2TopFlap = group.children.find(c => c.panelName.includes('side2TopFlap'));
  const side3TopFlap = group.children.find(c => c.panelName.includes('side3TopFlap'));
  const side4TopFlap = group.children.find(c => c.panelName.includes('side4TopFlap'));

  const side1TopFlapDim = getObjectDimensions(side1TopFlap);
  const side2TopFlapDim = getObjectDimensions(side2TopFlap);
  const side3TopFlapDim = getObjectDimensions(side3TopFlap);
  const side4TopFlapDim = getObjectDimensions(side4TopFlap);
  

  // @TODO: make preparation into function(pivotPoint, panel, openAngle, axis)
  // SIDE 1 TOP FLAP PREPARATION
  // ------------------------------------------------------------------------------------
  side1TopFlapPivotPoint.closedLidRotation = 0;
  side1TopFlapPivotPoint.openLidRotation = (Math.PI / 4) * 3;

  const originalS1TFPosition = side1TopFlap.position.clone();
  side1TopFlapPivotPoint.position.copy(originalS1TFPosition);
  side1TopFlapPivotPoint.position.z -= side1TopFlapDim.depth / 2

  addObjectToPivotPointAndAdjustPosition(side1TopFlapPivotPoint, side1TopFlap);
  // ------------------------------------------------------------------------------------

  // SIDE 2 TOP FLAP PREPARATION
  // ------------------------------------------------------------------------------------
  side2TopFlapPivotPoint.closedLidRotation = 0;
  side2TopFlapPivotPoint.openLidRotation = (Math.PI / 4) * 3;

  const originalS2TFPosition = side2TopFlap.position.clone();
  side2TopFlapPivotPoint.position.copy(originalS2TFPosition);
  side2TopFlapPivotPoint.position.x += side2TopFlapDim.width / 2

  addObjectToPivotPointAndAdjustPosition(side2TopFlapPivotPoint, side2TopFlap);
  // ------------------------------------------------------------------------------------

  // SIDE 3 TOP FLAP PREPARATION
  // ------------------------------------------------------------------------------------
  side3TopFlapPivotPoint.closedLidRotation = 0;
  side3TopFlapPivotPoint.openLidRotation = -(Math.PI / 4) * 3;

  const originalS3TFPosition = side3TopFlap.position.clone();
  side3TopFlapPivotPoint.position.copy(originalS3TFPosition);
  side3TopFlapPivotPoint.position.z += side3TopFlapDim.depth / 2

  addObjectToPivotPointAndAdjustPosition(side3TopFlapPivotPoint, side3TopFlap);
  // ------------------------------------------------------------------------------------

  // SIDE 4 TOP FLAP PREPARATION
  // ------------------------------------------------------------------------------------
  side4TopFlapPivotPoint.closedLidRotation = 0;
  side4TopFlapPivotPoint.openLidRotation = -(Math.PI / 4) * 3;

  const originalS4TFPosition = side4TopFlap.position.clone();
  side4TopFlapPivotPoint.position.copy(originalS4TFPosition);
  side4TopFlapPivotPoint.position.x -= side4TopFlapDim.width / 2

  addObjectToPivotPointAndAdjustPosition(side4TopFlapPivotPoint, side4TopFlap);
  // ------------------------------------------------------------------------------------

  group.add(side1TopFlapPivotPoint);
  group.add(side2TopFlapPivotPoint);
  group.add(side3TopFlapPivotPoint);
  group.add(side4TopFlapPivotPoint);

  tl.to(side1TopFlapPivotPoint.rotation, { x: side1TopFlapPivotPoint.openLidRotation, duration: 1.2, ease: 'power1.out' })
  .to(side3TopFlapPivotPoint.rotation, { x: side3TopFlapPivotPoint.openLidRotation, duration: 1.2, ease: 'power1.out' }, 0.2)
  .to(side2TopFlapPivotPoint.rotation, { z: side2TopFlapPivotPoint.openLidRotation, duration: 1.2, ease: 'power1.out' }, 1.2)
  .to(side4TopFlapPivotPoint.rotation, { z: side4TopFlapPivotPoint.openLidRotation, duration: 1.2, ease: 'power1.out' }, 1.4);

  tl.timeScale(2);

  return tl
}

function addObjectToPivotPointAndAdjustPosition(pivotPoint, panel) {
  const originalPanelPosition = panel.position.clone();

  pivotPoint.add(panel);

  const newPanelPosition = originalPanelPosition.sub(pivotPoint.position)
  panel.position.copy(newPanelPosition);
}

function newFoldPanels(box, group) {

  // Get Box Width, Length, Depth
  const {
    width: W,
    length: L,
    depth: D
  } = box;

  // Get Box Guide

  const {
    x: guideX,
    y: guideY
  } = box.getGuidePoint()

  const boxGuideObj = new THREE.Object3D();
  boxGuideObj.position.set(guideX, 0, guideY);
  group.add(boxGuideObj);

  // Visualize Guide Point
  const cubeGeo = new THREE.SphereGeometry(0.5, 4, 2);
  const cubeMat = new THREE.MeshStandardMaterial({
    wireframe: true,
    color: 0x0000FF,
  })
  const cubeMesh = new THREE.Mesh(cubeGeo, cubeMat);
  boxGuideObj.add(cubeMesh);

  let dim, bb, center;
  let pointNorth, pointSouth, pointWest, pointEast;

  // central panel
  const pBottom = group.children.find(c => c?.panelName.includes('outsideBottom'));
  dim = getObjectDimensions(pBottom)
  bb = new THREE.Box3().setFromObject(pBottom);
  center = new THREE.Vector3();
  bb.getCenter(center);

  pointWest = new THREE.Vector3();
  pointWest.x -= dim.width / 2;
  // console.log('pointWest', pointWest)
  putDebugCube(pBottom, pointWest)

  pointEast = new THREE.Vector3();
  pointEast.x += dim.width / 2;
  // console.log('pointEast', pointEast)
  putDebugCube(pBottom, pointEast)

  pointNorth = new THREE.Vector3();
  pointNorth.z -= dim.depth / 2 - MT;
  // console.log('pointNorth', pointNorth)
  putDebugCube(pBottom, pointNorth)

  pointSouth = new THREE.Vector3();
  pointSouth.z += dim.depth / 2 - MT;
  // console.log('pointSouth', pointSouth)
  putDebugCube(pBottom, pointSouth)

  // front panel
  const pFront = group.children.find(c => c?.panelName.includes('FrontWall'));
  dim = getObjectDimensions(pFront)
  bb = new THREE.Box3().setFromObject(pFront);
  center = new THREE.Vector3();
  bb.getCenter(center);

  pointWest = new THREE.Vector3();
  pointWest.x -= dim.width / 2;
  putDebugCube(pFront, pointWest)

  pointEast = new THREE.Vector3();
  pointEast.x += dim.width / 2;
  putDebugCube(pFront, pointEast)



}

export default function useShippingBoxModel(box, group, lidTimeline, scene) {

  // fold panels into a box
  foldPanels(box, group, scene);

  // newFoldPanels(box, group);

  setPanelMaterials(group);

  lidTimeline.value = initLidAnimation(group)

  scene.add(group);
}
